import { combineReducers } from 'redux';
import types from './types';

//避難所名
const shelterName = (state = '', action) => {
  switch (action.type) {
    case types.SET_UPD_SHELTERT_NAME:
      return action.shelterName;
    default:
      return state;
  }
};

//個人情報一覧
const kojinInfo = (state = [], action) => {
  switch (action.type) {
    case types.SET_UPD_KOJIN_INFO:
      return action.kojinInfo;
    default:
      return state;
  }
};

const reducer = combineReducers({
  shelterName,
  kojinInfo
});
export default reducer;
